<template>
  <div class="promotions-container">
    <div v-if="promotions && promotions.length > 0" class="promotions-wrapper">
      <div v-for="(promotion, i) in promotions" :key="i" class="promotion-item" :class="promotion.event" @click.stop="togglePromotion(promotion)">
        <div class="promotion-banner">
          <div class="promo-img" :style="[{backgroundImage: 'url(' + mediaServer(`/static/promotions/generic_banner_${i % 2 === 0 ? 1 : 2}.jpg`) + ') !important'}]">
          </div>
          <p class="promotion-title">{{promotion.description}}</p>
          <p class="promotion-text-generic">{{ $t('Promotions.BaseBannerText') }}</p>
        </div>
        <div class="promo-content">
          <div class="promotion-note">
            {{promotion.note}}
          </div>
          <div class="promo-buttons">
            <v-btn @click="moreInfo(promotion.description, promotion.idmmprpromotype, promotion.id, promotion.idmpcampaign)" class="event-btn">
              {{ isLoggedIn || promotion.idmmprpromotype === 'REGISTRATION' ?
                  $t('Promotions.Action.' + promotion.idmmprpromotype) :
                  $t('Promotions.Login') + ' ' + $t('Promotions.Action.' + promotion.idmmprpromotype) }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div v-if="promotions && promotions.length === 0">
      <p class="no-promotions-found"><v-icon color="info" class="mr-1" size="18">info</v-icon>{{ $t('Promotions.AccountPage.NoActivePromotions.Msg') }}</p>
    </div>
      <v-layout row justify-center>
        <v-dialog
          content-class="dialog-promotions-static-content"
          v-model="popupDialog"
          max-width="1154"
        >
         <div class="closeDialog">
            <v-btn flat @click="closePopupDialog()" class="close"><v-icon>close</v-icon></v-btn>
          </div>
          <div class="promotion-popup-content">
            <div class="promotion-text" v-if="html" v-html="html"></div>
            <div class="popup_buttons" v-if="!isLoggedIn || promoType === 'ALLPLAYERS'">
              <v-btn
                class="event-btn"
                flat="flat"
                @click="action(promoType)"
                v-if="promoType && !isLoggedIn"
              >
                {{ promoType === 'REGISTRATION' ?
                  $t('Promotions.Action.REGISTRATION') :
                  $t('Promotions.Login') + ' ' + $t('Promotions.Action.' + promoType) }}
              </v-btn>
              <v-btn
                class="event-btn"
                flat="flat"
                @click="action(promoType)"
                v-if="promoType === 'ALLPLAYERS' && isLoggedIn"
              >
                {{ $t('Promotions.Action.' + promoType) }}
              </v-btn>
            </div>
            <div v-if="isLoggedIn && (promoType==='REFERAFRIEND' || promoType==='PICKCLAIM')" class="promo_components_holder">
              <template v-if="promoType==='REFERAFRIEND'">
                <ReferAFriend></ReferAFriend>
              </template>
              <template v-if="promoType==='PICKCLAIM'">
                <PickAndClaim :promoId='promoId' :campaignId='campaignId' :isOnPsPromotionsPage='true'></PickAndClaim>
              </template>
              <!-- <AdHocPromoCodes></AdHocPromoCodes>
              <AccountVouchers></AccountVouchers> -->
            </div>
          </div>
        </v-dialog>
      </v-layout>
  </div>
</template>

<script>
import config from '@/config'
import store from '@/store'
import moment from 'moment'
import Branding from '@/components/mixins/Branding'
import { localeProperties } from '@/library/locale/i18n'
import Url from '@/components/mixins/Url'
import http from 'axios'
import StaticContent from '@/components/common/StaticContent'
import mobileBridge from '@/library/mobileBridge'
import Gtm from '@/components/mixins/Gtm'
import Screen from '@/components/mixins/Screen'
import PickAndClaim from '@/components/account/PickAndClaim'
import ReferAFriend from '@/components/account/ReferAFriend'
import AccountVouchers from '@/components/account/AccountVouchers'
import AdHocPromoCodes from '@/components/account/AdHocPromoCodes'

export default {
  data: () => {
    return {
      promotionPopup: undefined,
      promotionObj: undefined,
      eventMap: {
        'DEPOSIT': 'Deposit',
        'TRADEPLACED': 'Trade Placed'
      },
      moreInfoPromotion: null,
      html: false,
      popupDialog: false,
      promoType: false,
      promoId: false,
      campaignId: false
    }
  },
  mixins: [
    Branding,
    Url,
    Gtm,
    Screen
  ],
  components: {
    StaticContent,
    PickAndClaim,
    ReferAFriend,
    AccountVouchers,
    AdHocPromoCodes
  },
  computed: {
    dateFormats () {
      return config.app.dateFormats
    },
    promotions () {
      let promotions = null
      if (this.$i18n.locale && localeProperties && localeProperties.getSupportedLocales && localeProperties.getSupportedLocales.length > 1) {
        promotions = store.getters['getPromotionsTrans']
      } else {
        promotions = store.getters['getPromotions']
      }
      let filterByAllowedPromotionTypes = promotions ? promotions.filter((promo) => this.allowedPromotionTypes.includes(promo.idmmprpromotype)) : []
      return filterByAllowedPromotionTypes
    },
    currencySymbol () {
      return config.app.CURRENCY
    },
    placeholders () {
      return {
        '{mediaServer}': this.mediaServerHostname(),
        '{brand}': config.app.BRAND
      }
    },
    staticContentPath () {
      return this.mediaServerHostname() + this.staticcontentpath
    },
    allowedPromotionTypes () {
      return config.app.autoconf.ALLOWED_PROMOTION_TYPES
    },
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    biometricsAvailability () {
      return store.getters['getBiometricsAvailability']
    },
    biometricsSettings () {
      return store.getters['getBiometricsSettings']
    },
    MobilelocalServer () {
      return window.ctsautoconf.MOBILE_LS || false
    },
    url () {
      let getLocaleAndFileName = this.$i18n.locale ? `${this.moreInfoPromotion}/${this.$i18n.locale}` : this.moreInfoPromotion
      return this.mediaServerHostname() + `/static/promotions/content/${getLocaleAndFileName}/description.html`
    },
    isWebViewAndMobile () {
      return store.getters['getWebViewAndMobile']
    },
    isOpenedFromWebView () {
      return store.getters['getIsOpenedFromWebView']
    },
    isFitForPLayEnabled () {
      return config.app.autoconf.ENABLE_FIT_FOR_PLAY
    }
  },
  methods: {
    togglePromotion (promotion) {
      this.promotionPopup = !this.promotionPopup
      this.promotionObj = promotion
    },
    parseDateTime (dateTime) {
      return moment(dateTime).format(this.dateFormats.longDate)
    },
    getHtml () {
      http.get(this.url).then((response) => {
        if (response && response.data) {
          this.html = response.data
          this.replacePlaceholders()
        }
      }).catch((error) => {
        console.log('PS Promotion Error:', error)
      })
    },
    replacePlaceholders () {
      if (this.placeholders && this.html) {
        for (const placeholder in this.placeholders) {
          if (this.placeholders.hasOwnProperty(placeholder) && this.placeholders[placeholder]) {
            let search = new RegExp(placeholder, 'g')
            this.html = this.html.replace(search, this.placeholders[placeholder])
            this.popupDialog = true
          }
        }
      }
    },
    moreInfo (promoName, promoType, promotionId, promoCampaignId) {
      this.moreInfoPromotion = promoName.replace(/ /g, '_').toLowerCase()
      this.promoType = promoType
      this.promoId = promotionId
      this.campaignId = promoCampaignId
      this.getHtml()
    },
    action (event) {
      if (event === 'ALLPLAYERS') this.goToDeposit('deposit')
      if (event === 'PICKCLAIM') this.accountSection('PICKCLAIM')
      if (event === 'REFERAFRIEND') this.accountSection('REFERAFRIEND')
      if (event === 'REGISTRATION') this.goToRegistrationPage()
    },
    accountSection (type) {
      let promotionType = type === 'PICKCLAIM' ? 'pick-and-claim' : 'refer-a-friend'
      if (!this.isLoggedIn) {
        sessionStorage.tempPromotionSection = JSON.stringify({'name': 'promotions', 'query': promotionType})
        this.openDialogLogin()
        return false
      }
      this.$router.replace({
        name: 'promotions',
        query: {
          [promotionType]: true
        }
      }).catch(err => { console.log(err) })
    },
    goToDeposit () {
      if (!this.isLoggedIn) {
        sessionStorage.tempPromotionSection = JSON.stringify({'name': 'deposit'})
        this.openDialogLogin()
        return false
      } else {
        if (this.isWebViewAndMobile || window.ctsautoconf.MOBILE_LS) {
          store.dispatch('overlayState/activateMyAccountDialog')
          return false
        }
        store.dispatch('overlayState/activateMyAccountDesktopDialog')
        return false
      }
    },
    openDialogLogin () {
      let faceIdState = (window.ctsautoconf.MOBILE_LS && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN) ? JSON.parse(localStorage.biometricsState) : false
      if ((this.biometricsAvailability && this.biometricsAvailability.biometrics === 'DATA') && faceIdState && (this.MobilelocalServer && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN && !this.isFitForPLayEnabled)) {
        store.dispatch('overlayState/activateLoginDialog')
        mobileBridge.bridgeSendRequest('readData')
        this.sendGTMClickEvent('login', 'open login dialog', 'login-btn', 'top header')
        return false
      } else if ((this.biometricsAvailability && this.biometricsAvailability.biometrics === 'DATA') && faceIdState && (this.MobilelocalServer && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN && this.isFitForPLayEnabled)) {
        store.dispatch('overlayState/activateLoginDialog')
        this.sendGTMClickEvent('login', 'open login dialog', 'login-btn', 'top header')
        return false
      }
      store.dispatch('overlayState/activateLoginDialog')
      this.sendGTMClickEvent('login', 'open login dialog', 'login-btn', 'top header')
    },
    termsAndConditions () {
      var urlToOpen = window.location.origin + '/info/terms-and-conditions'
      if (this.mobileBigAndBelow && this.isOpenedFromWebView) {
        mobileBridge.bridgeSendRequest('openLink', urlToOpen)
      } else {
        this.$router.push({name: 'info', params: { infopagename: 'terms-and-conditions' }})
      }
    },
    closePopupDialog () {
      this.popupDialog = false
    },
    goToRegistrationPage () {
      if (this.$route.name !== 'account-joinUs') this.$router.push({name: 'account-joinUs'})
      this.sendGTMClickEvent('register', 'open registration page', 'join-btn', 'login dialog')
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/css/config'
@import '~@/css/mixins'

.promotion-banner
.promo-img
  max-height 136px
  height 136px
  background-size 100%
.promotion-note
  padding 10px 0
  min-height 100px
.promo-content
  box-shadow 0 0 3px 0 rgba(0, 0, 0, 0.161)
  padding 5px 10px 20px 10px
.terms-text
.promotion-text
  padding-bottom 30px
  >>>p
  >>>ul li
  >>>ol li
    font-size 14px
  >>>h1
    font-size 24px
  >>>h3
    font-size 18px
.promo-buttons
  display flex
  justify-content: space-between
  >>>.v-btn
    min-width 110px
    padding 0 5px
    margin 0
    width auto
    &.more-info-btn
      background #003764
      background-color #003764
      color #fff
      border-radius 3px
      border 0px
      margin-right 10px
      flex 1
    &.event-btn
      background #fff
      background-color #fff
      color #003764
      border-radius 3px
      border 2px solid #003764
      flex 2
.popup_buttons
  display flex
  justify-content: space-between
  @media mobile-big-and-below
    justify-content: flex-start
    flex-direction column-reverse
  .v-btn
    font-family 'Open Sans SemiBold'
  .terms-btn
    text-decoration: underline
    color #003764
    margin-left: auto
.promotions-container
  background: white
  margin 0 24px 0 0
  padding 20px
  cursor default
  @media mobile-big-and-below
    margin 0
    padding 10px
.promotions-wrapper
  display flex
  flex-wrap wrap
  justify-content space-between
.caca
  position relative
  .flex.close
    position absolute
    right 45px
    width 50px
    @media mobile-big-and-below
      width initial
      right -35px
    :before,
    span
      display none
.promotions-title
  text-align: center

.no-promotions-found
  text-align: center
  margin-top: 32px

.promotion-item
  padding 0px 5px 10px 5px
  flex 0 0 50%
  background transparent
  color #1B2C56
  font-family "Open Sans SemiBold"
  font-size 14px
  line-height 21px
  margin 10px 0
  cursor pointer
  min-height 100px
  max-width 48%
  @media mobile-big-and-below
    flex unset
    max-width 100%
    width 100%

  .promotion-banner
    img
      object-fit contain
      max-width 100%
    .promotion-title, .promotion-text-generic
      position: relative
      top: -80px
      color: var(--promo-item-title-color)
      text-align: center
    .promotion-title
      text-transform uppercase
      margin 0

.promotion-item__title
  font-weight: bold
  font-size: 16px

.promotion-item__content
  display: flex
  align-items: center
.promotion-overlay
  position fixed
  display block
  width 100%
  height 100%
  background-color rgba(17,28,44,0.9)
  top 0
  left 0
  z-index 201
  .promotions-overlay-wrapper
    display block
    position relative
    width 60%
    margin auto
    min-height 350px
    background-color rgba(255,255,255,1)
    top 30%
    @media mobile-big-and-below
      top 0
      width 100%
      height 100%
    .promotion-item__title
      padding 15px
      text-transform uppercase
      text-align center
    .promotion-item-note
      font-size 14px
      padding: 10px
      white-space pre-wrap
      overflow-y auto
      height 300px
      @media mobile-big-and-below
        height unset
        max-height 100%
        padding-bottom 135px
    .date-from,
    .date-to
      font-size 14px
      padding 10px
      font-weight bold
    .min-reward,
    .max-reward
      font-size 14px
      padding 3px
      margin 2px 10px
      background #0b4da1
      color #fff
      border-radius 5px

.dates
  flex-grow: 1

.date-start-wrapper
  padding-right: 20px

@media mobile-big-and-below
  .date-start-wrapper, .date-end-wrapper
    display: block
    padding-right: 5px

.date-start
  font-weight: bold

.date-end
  font-weight: bold

.amount
  flex-grow: 0
  font-size: 1.2em

.promotions-header
  padding: 8px
  background: #0b4da1
  color: white
  text-align: center
  margin-top: 8px

.error-message
  text-align: center
  color: white
  margin: 10px 0
  padding: 10px

.is-processing
  text-align: center

.page-description
  text-align justify
  font-size 14px
.v-icon
  font-size 35px
  color #0b4da1!important
.igt
  .promotion-item-wrapper
    display: flex
    align-items: center
    height: 100%
    .v-icon
      color #fff !important
    .promo_icon .v-icon
      margin-right 10px
    .promotion-item__title
      font-family: "Open Sans SemiBold"
      line-height 16px
      font-weight normal
      padding-bottom 10px
    .promotion-content
      font-size 14px
    .promo_readmore
      margin-left auto
>>>.promo-heading
  margin-bottom 10px
  line-height normal
.promo_components_holder
  >>>.pnc-container
  >>>.raf-friend-holder
    max-width 50%
    margin auto
    font-size 14px
    @media mobile-big-and-below
      max-width 100%
.promo_components_holder
  >>>.grouped-promos
      border 0px !important
      .promo_details
        padding-top 0px
  >>>.promo_details
      padding-top: 5px
      line-height: normal
      font-size: 13px
  >>>.claimed-promos
    .claimed-promos-header
      border 0px !important
      font-size: 18px
      margin-bottom 10px
    .see_all_claimed_promos
      font-size 14px
      display flex
      align-items center
      justify-content: center
      line-height normal
      @media mobile-big-and-below
        padding-bottom 10px
      .v-icon
        cursor pointer
  >>>.pnc-container .available-promos
      .promos
        margin-bottom 0 !important
        .standalone-promos
          justify-content: center !important
          align-items: center !important

</style>



// WEBPACK FOOTER //
// src/components/pages/PromotionsPage.vue